module.exports = __webpack_public_path__ + "img/icon_qh.0ba1f450.png";